import api from '@/api_alv'
import i18n from '@/assets/i18n/i18n'

const DIR = 'label/statistics'

const DEFAULT_FILTERS = {
    "monthFrom": null,
    "monthTo": null,
    "salesType": [],
    "platforms": null,
    "region": {
        "include": [],
        "exclude": []
    },
    "search": null,
    "typeOfReport": null,
    "rows": null
}

const state = {
    labelStatistics: [],
    selectedLabelStatisticsReport: "",
    labelStatisticsSearch: "",
    selectedLabelStatisticsRows: null,
    selectedLabelStatisticsColumnTitles: null,
    selectedLabelStatisticsOutputValues: null,
    //FILTERS SECTION and Favourite
        // From Month, To Month, Regions
    selectedLabelStatisticsFrom: null,
    selectedLabelStatisticsTo: null,
    selectedLabelStatisticsRegions: {
        include: [],
        exclude: []
    },
    selectedLabelStatisticsRegionsString: "",
        //Sales Type
    selectedLabelStatisticsSalesType: ["TS"],
        //Platforms
    selectedLabelStatisticsPlatforms: [],
        //Left Chart
    selectedLabelStatisticsLeftChart: "byPlatforms",
        //Right Chart
    selectedLabelStatisticsRightChart: "byCountries",
        //Data Table
    selectedLabelStatisticsDataTable: "top100Tracks",
        //Product Dialog Filter
            //Type Search
    labelStatisticSearchType: 0,
            //Search Modes
    labelStatisticsSearchMode: 0,
            //Track
    labelStatisticsTrackOptions: [],
    labelStatisticsDetailsTrack: null,
            //Release
    labelStatisticsReleaseOptions: [],
    labelStatisticsDetailsRelease: null,
            //Product
    labelStatisticsDetailsProduct: null,
    selectedLabelStatisticsProduct: null,
            //Tags
    labelStatisticsDetailsTags: null,
    labelStatisticsTagsSearchMessage: null,
        //Label Search (for Product dialog)
    labelStatisticsLabelDropdownOptions: [],
    labelStatisticsSelectedLabel: null,
    labelStatisticsLabelSearchMessage: null,
        //Artist
    labelStatisticsArtistOptions: [],
    labelStatisticsDetailsArtist: null,
        //Distributors
    labelStatisticsDistributorsDropdownValues: [],
    selectedLabelStatisticsDistributors: [],
        // Favourits Dropdown
    labelStatisticsFavoriteDropdownValues: [],
    selectedLabelStatisticsFavorite: null,
    showLabelStatisticsCreateNewFavoriteDialog: false,
    labelStatisticsCreateNewFavoriteDialogDetailsFavoriteName: null,
    tempSaveSelectedLabelStatisticsFavorite: [],

    //CHART SECTION AND CARD SECTION
    showLabelStatisticsChartsSection: false,
    showLabelStatisticsBarChart: false,
    labelStatisticsBarChart: null,
        //First Pie Chart
    labelStatisticsFirstPieChartTitle: '',
    labelStatisticsFirstPieChartSeriesTitle: '',
    labelStatisticsFirstPieChartSeriesData: [],
        //Second Pie Chart
    labelStatisticsSecondPieChartTitle: '',
    labelStatisticsSecondPieChartSeriesTitle: '',
    labelStatisticsSecondPieChartSeriesData: [],
        //Card Section
    labelStatisticCards: [],

    //DATATABLE SECTION
    //Datatable
    labelStatisticsDatatableData: [],
}

const getters = {
    getLabelStatistics(state) { return state.labelStatistics },
    getSelectedLabelStatisticsReport(state) { return state.selectedLabelStatisticsReport },
    getLabelStatisticsSearch(state) { return state.labelStatisticsSearch },
    getSelectedLabelStatisticsRows(state) { return state.selectedLabelStatisticsRows },
    getSelectedLabelStatisticsColumnTitles(state) { return state.selectedLabelStatisticsColumnTitles },
    getSelectedLabelStatisticsOutputValues(state) { return state.selectedLabelStatisticsOutputValues },
    getSelectedLabelStatisticsFrom(state) { return state.selectedLabelStatisticsFrom },
    getSelectedLabelStatisticsTo(state) { return state.selectedLabelStatisticsTo },
    getSelectedLabelStatisticsRegions(state) { return state.selectedLabelStatisticsRegions },
    getSelectedLabelStatisticsRegionsInclude(state) { return state.selectedLabelStatisticsRegions.include },
    getSelectedLabelStatisticsRegionsExclude(state) { return state.selectedLabelStatisticsRegions.exclude  },
    getSelectedLabelStatisticsRegionsString(state) { return state.selectedLabelStatisticsRegionsString },
    getSelectedLabelStatisticsSalesType(state) { return state.selectedLabelStatisticsSalesType},
    getSelectedLabelStatisticsPlatforms(state) { return state.selectedLabelStatisticsPlatforms},
    getSelectedLabelStatisticsDistributors(state) { return state.selectedLabelStatisticsDistributors},
    getSelectedLabelStatisticsProduct(state) { 
        if(state.labelStatisticsDetailsProduct) return state.selectedLabelStatisticsProduct
        else return null    
    },
    getSelectedLabelStatisticsLeftChart(state) { return state.selectedLabelStatisticsLeftChart },
    getSelectedLabelStatisticsRightChart(state) { return state.selectedLabelStatisticsRightChart },
    getSelectedLabelStatisticsDataTable(state) { return state.selectedLabelStatisticsDataTable },
    //Product Dialog
        //Search Type
    getSelectedLabelStatisticsSearchType(state) { return state.labelStatisticSearchType },
        //Search Mode
    getSelectedLabelStatisticsSearchMode(state) { return state.labelStatisticsSearchMode },
        //Track
    getLabelStatisticsTrackOptions(state) { return state.labelStatisticsTrackOptions },
    getLabelStatisticsDetailsTrack(state) { return state.labelStatisticsDetailsTrack },
        //Release
    getLabelStatisticsReleaseOptions(state) { return state.labelStatisticsReleaseOptions },
    getLabelStatisticsDetailsRelease(state) { return state.labelStatisticsDetailsRelease },
        //Product Details
    getLabelStatisticsDetailsProduct(state) { return state.labelStatisticsDetailsProduct }, 
        //Tags
    getLabelStatisticsDetailsTags(state)    { return state.labelStatisticsDetailsTags },
    getLabelStatisticsTagsSearchMessage()   { return state.labelStatisticsTagsSearchMessage },
    // Label Search (for Product dialog)
    getLabelStatisticsLabelDropdownOptions(state) { return state.labelStatisticsLabelDropdownOptions },
    getLabelStatisticsSelectedLabel(state) { return state.labelStatisticsSelectedLabel },
    getLabelStatisticsLabelSearchMessage(state) { return state.labelStatisticsLabelSearchMessage },
    // Artists Dropdown
    getLabelStatisticsArtistOptions(state) { return state.labelStatisticsArtistOptions },
    getLabelStatisticsDetailsArtist(state) { return state.labelStatisticsDetailsArtist },
    // Distributors Dropdown
    getLabelStatisticsDistributorsDropdownValues(state) { return state.labelStatisticsDistributorsDropdownValues },
    // Favourits Dropdown
    getLabelStatisticsFavoriteDropdownValues(state) { return state.labelStatisticsFavoriteDropdownValues },
    getSelectedLabelStatisticsFavorite(state) { return state.selectedLabelStatisticsFavorite },
    getShowLabelStatisticsCreateNewFavoriteDialog(state) { return state.showLabelStatisticsCreateNewFavoriteDialog },
    getLabelStatisticsCreateNewFavoriteDialogDetailsFavoriteName(state) { return state.labelStatisticsCreateNewFavoriteDialogDetailsFavoriteName },
    getTempSaveSelectedLabelStatisticsFavorite(state) { return state.tempSaveSelectedLabelStatisticsFavorite },
    //First Pie Chart
    getLabelStatisticsFirstPieChartTitle(state) { return state.labelStatisticsFirstPieChartTitle },
    getLabelStatisticsFirstPieChartSeriesTitle(state) { return state.labelStatisticsFirstPieChartSeriesTitle },
    getLabelStatisticsFirstPieChartSeriesData(state) { return state.labelStatisticsFirstPieChartSeriesData },
    //Second Pie Chart
    getLabelStatisticsSecondPieChartTitle(state) { return state.labelStatisticsSecondPieChartTitle },
    getLabelStatisticsSecondPieChartSeriesTitle(state) { return state.labelStatisticsSecondPieChartSeriesTitle },
    getLabelStatisticsSecondPieChartSeriesData(state) { return state.labelStatisticsSecondPieChartSeriesData },
    getShowLabelStatisticsChartsSection(state) { return state.showLabelStatisticsChartsSection },
    //Bar Chart
    getShowLabelStatisticsBarChart(state){ return state.showLabelStatisticsBarChart },
    getLabelStatisticsBarChart(state) { return state.labelStatisticsBarChart },
    getLabelStatisticsBarChartData(state) { return state.labelStatisticsBarChart.details },
    //Card Section
    getLabelStatisticsCards(state) { return state.labelStatisticCards },
    //Datatable
    getLabelStatisticsDatatableData(state) { return state.labelStatisticsDatatableData }
}

const mutations = {
    setLabelStatistics: (state, labelStatistics) => { state.labelStatistics = labelStatistics },
    setSelectedLabelStatisticsReport: (state, selected) => { state.selectedLabelStatisticsReport = selected },
    setLabelStatisticsSearch: (state, search) => { state.labelStatisticsSearch = search },
    setSelectedLabelStatisticsRows: (state, selected) => { state.selectedLabelStatisticsRows = selected },
    setSelectedLabelStatisticsColumnTitles: (state, selected) => { state.selectedLabelStatisticsColumnTitles = selected },
    setSelectedLabelStatisticsOutputValues: (state, selected) => { state.selectedLabelStatisticsOutputValues = selected },
    setSelectedLabelStatisticsFrom: (state, from) => { state.selectedLabelStatisticsFrom = from },
    setSelectedLabelStatisticsTo: (state, to) => { state.selectedLabelStatisticsTo = to },
    setSelectedLabelStatisticsRegions: (state, regions) => { state.selectedLabelStatisticsRegions = regions },
    setSelectedLabelStatisticsRegionsInclude: (state, include) => { state.selectedLabelStatisticsRegions.include = include },
    setSelectedLabelStatisticsRegionsExclude: (state, exclude) => { state.selectedLabelStatisticsRegions.exclude = exclude },
    setSelectedLabelStatisticsRegionsString: (state, string) => { state.selectedLabelStatisticsRegionsString = string },
    setSelectedLabelStatisticsSalesType: (state, value) => { state.selectedLabelStatisticsSalesType = value },
    setSelectedLabelStatisticsPlatforms: (state, value) => { state.selectedLabelStatisticsPlatforms = value },
    setSelectedLabelStatisticsDistributors: (state, value) => { state.selectedLabelStatisticsDistributors = value },
    setSelectedLabelStatisticsProduct: (state, value) => { state.selectedLabelStatisticsProduct = value },
    setSelectedLabelStatisticsLeftChart: (state, value) => { state.selectedLabelStatisticsLeftChart = value },
    setSelectedLabelStatisticsRightChart: (state, value) => { state.selectedLabelStatisticsRightChart = value },
    setSelectedLabelStatisticsDataTable: (state, value) => { state.selectedLabelStatisticsDataTable = value },
    //Product Dialog
        // Search Type
    setSelectedLabelStatisticsSearchType:(state, value) => { state.labelStatisticSearchType = value },
        // Search Modes
    setSelectedLabelStatisticsSearchMode:(state, value ) =>  { state.labelStatisticsSearchMode = value },
        // Track
    setLabelStatisticsTrackOptions:(state, value ) => { state.labelStatisticsTrackOptions = value },
    setLabelStatisticsDetailsTrack:(state, value) => { 
        state.labelStatisticsDetailsTrack = value
        state.labelStatisticsDetailsProduct = value
    },
        // Release
    setLabelStatisticsReleaseOptions:(state, value ) => { state.labelStatisticsReleaseOptions = value },
    setLabelStatisticsDetailsRelease:(state, value) => { 
        state.labelStatisticsDetailsRelease = value
        state.labelStatisticsDetailsProduct = value
    },
        //Product
    setLabelStatisticsDetailsProduct: (state, value) => { state.labelStatisticsDetailsProduct = value }, 
        // Tags
    setLabelStatisticsDetailsTags: (state, value) => { state.labelStatisticsDetailsTags = value },
    setLabelStatisticsTagsSearchMessage: (state, value) => { state.labelStatisticsTagsSearchMessage = value},
    // Label Search (for Product dialog)
    setLabelStatisticsLabelDropdownOptions: (state, value) => { state.labelStatisticsLabelDropdownOptions = value },
    setLabelStatisticsSelectedLabel: (state, value) => { state.labelStatisticsSelectedLabel = value },
    setLabelStatisticsLabelSearchMessage: (state, value) => { state.labelStatisticsLabelSearchMessage = value },
    //Artists Dropdown
    setLabelStatisticsArtistOptions:(state, value ) => { state.labelStatisticsArtistOptions = value },
    setLabelStatisticsDetailsArtist:(state, value ) => { state.labelStatisticsDetailsArtist = value },
    // Favourits Dropdown
    setLabelStatisticsFavoriteDropdownValues: (state, values) => { state.labelStatisticsFavoriteDropdownValues = values },
    setSelectedLabelStatisticsFavorite: (state, value) => { 
        if(value !== null) {
            if(value.hasOwnProperty('value')) {
                if(value.value === 'deleteFavorite') state.tempSaveSelectedLabelStatisticsFavorite = state.selectedLabelStatisticsFavorite
            }
        }
        state.selectedLabelStatisticsFavorite = value 
    },
    setShowLabelStatisticsCreateNewFavoriteDialog: (state, show) => { state.showLabelStatisticsCreateNewFavoriteDialog = show },
    setLabelStatisticsCreateNewFavoriteDialogDetailsFavoriteName: (state, name) => { state.labelStatisticsCreateNewFavoriteDialogDetailsFavoriteName = name },
    setTempSaveSelectedLabelStatisticsFavorite: (state, selected) => { state.tempSaveSelectedLabelStatisticsFavorite = selected },
    //First Pie Chart
    setLabelStatisticsFirstPieChartTitle: (state, value)  => { state.labelStatisticsFirstPieChartTitle = value },
    setLabelStatisticsFirstPieChartSeriesTitle: (state, value)  => { state.labelStatisticsFirstPieChartSeriesTitle = value },
    setLabelStatisticsFirstPieChartSeriesData: (state, value)  => { state.labelStatisticsFirstPieChartSeriesData = value },

    //Second Pie CHart
    setLabelStatisticsSecondPieChartTitle:(state, value) => { state.labelStatisticsSecondPieChartTitle = value},
    setLabelStatisticsSecondPieChartSeriesTitle:(state, value) => {  state.labelStatisticsSecondPieChartSeriesTitle = value},
    setLabelStatisticsSecondPieChartSeriesData: (state, value) => {  state.labelStatisticsSecondPieChartSeriesData = value},
    setShowLabelStatisticsChartsSection: (state, value) => { state.showLabelStatisticsChartsSection = value },

    //Bar Chart
    setShowLabelStatisticsBarChart: (state, value) => { state.showLabelStatisticsBarChart = value },
    setLabelStatisticsBarChart: (state, value) => {state.labelStatisticsBarChart = value },
    //Card Section
    setLabelStatisticsCards:(state, value) => { state.labelStatisticCards = value },
    //Datatable
    setLabelStatisticsDatatableData:(state, value) => { state.labelStatisticsDatatableData = value }
}

function isStatisticsFavoriteNameTaken(dropdownValues, favoriteName) {
    const name = String(favoriteName == null ? '' : favoriteName).trim()
    if (!name) return false
    return (dropdownValues || []).some((item) => {
        if (!item || item.divider) return false
        if (item.value === 'newFavorite' || item.value === 'deleteFavorite') return false
        if (item.text == null || item.text === '') return false
        if (String(item.text).startsWith('lang_')) return false
        return String(item.text).trim() === name
    })
}

const actions = {
    async fetchLabelStatistics({ commit }) {
        commit('setIsLoading', true)
        this._vm.$alvPlugin.storePagingInformations(0, 1, 0)
        commit('setNoDataText', 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND')
        commit('setLabelStatistics', [])
        commit('setIsLoading', false)
    },
    async labelStatisticsExportExcel({ getters, commit}) {
        let queryParams = {
            "action" : "export",
            "type" : "excel"
        }

        let metaData = {
            'fromMonth'     : getters.getSelectedLabelStatisticsFrom,
            'toMonth'       : getters.getSelectedLabelStatisticsTo,
            'rows'          : getters.getSelectedLabelStatisticsRows,
            'outputValues'  : getters.getSelectedLabelStatisticsOutputValues,
            'search'        : getters.getLabelStatisticsSearch,
            'typeOfReport'  : getters.getSelectedLabelStatisticsColumnTitles,
            'region'        : getters.getSelectedLabelStatisticsRegions
        }

        let response = await api.triggerAction(DIR, metaData, queryParams)
        if(response.error === -1) {
            api.getFileFromALV(response.response.path)
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
            })
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t(response.response.errorMsg)
            })
        }
    },
    async labelStatisticExportCsv({getters, commit}){
        commit('setIsLoading', true)
        let queryParams = {
            "action" : "export",
            "type"   : "csv"
        }

        let metaData = {
            'fromMonth'     : getters.getSelectedLabelStatisticsFrom,
            'toMonth'       : getters.getSelectedLabelStatisticsTo,
            'salesType'     : getters.getSelectedLabelStatisticsSalesType,
            'platforms'     : getters.getSelectedLabelStatisticsPlatforms,
            'distributors'  : getters.getSelectedLabelStatisticsDistributors,
            'artist'        : getters.getLabelStatisticsDetailsArtist,
            'region'        : getters.getSelectedLabelStatisticsRegions,
            'product'       : getters.getSelectedLabelStatisticsProduct,
            'leftChart'     : getters.getSelectedLabelStatisticsLeftChart,
            'rightChart'    : getters.getSelectedLabelStatisticsRightChart,
            'dataTable'     : getters.getSelectedLabelStatisticsDataTable,
            'searchType'    : getters.getSelectedLabelStatisticsSearchType,
            'searchMode'    : getters.getSelectedLabelStatisticsSearchMode
        }

        let response = await api.triggerAction(DIR, metaData, queryParams)

        if(response.error === -1) {
            api.getFileFromALV(response.response.path)
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERAL_SNACKBAR_DOWNLOAD_SUCCESSFULL')
            })
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t(response.response.errorMsg)
            })
        }

        commit('setIsLoading', false)

    },
    async labelStatisticReport({ getters, commit}) {
        commit('setShowLabelStatisticsChartsSection', false)
        commit('setLabelStatisticsDatatableData', [])
        commit('setIsLoading', true)
        let metaData = {
            'fromMonth'     : getters.getSelectedLabelStatisticsFrom,
            'toMonth'       : getters.getSelectedLabelStatisticsTo,
            'salesType'     : getters.getSelectedLabelStatisticsSalesType,
            'platforms'     : getters.getSelectedLabelStatisticsPlatforms,
            'distributors'  : getters.getSelectedLabelStatisticsDistributors,
            'artist'        : getters.getLabelStatisticsDetailsArtist,
            'region'        : getters.getSelectedLabelStatisticsRegions,
            'product'       : getters.getSelectedLabelStatisticsProduct,
            'leftChart'     : getters.getSelectedLabelStatisticsLeftChart,
            'rightChart'    : getters.getSelectedLabelStatisticsRightChart,
            'dataTable'     : getters.getSelectedLabelStatisticsDataTable,
            'searchType'    : getters.getSelectedLabelStatisticsSearchType,
            'searchMode'    : getters.getSelectedLabelStatisticsSearchMode
        }

        let response = await api.triggerAction(DIR + '/report', metaData, {})
        

        if(response.error === -1) {
            if(response.response.chart1){
                let data = response.response.chart1.details
                commit('setShowLabelStatisticsBarChart', false)
                commit('setLabelStatisticsFirstPieChartTitle', response.response.chart1.title)
                commit('setLabelStatisticsFirstPieChartSeriesTitle', 'Revenue')
                
                if(response.response.chart1.byMonths){
                    commit('setShowLabelStatisticsBarChart', response.response.chart1.byMonths)
                    commit('setLabelStatisticsBarChart', response.response.chart1)
                }
                if(data == null) {
                    commit('setLabelStatisticsFirstPieChartSeriesData', [])
                }else{
                    commit('setLabelStatisticsFirstPieChartSeriesData', data)
                }   
            }

            if(response.response.chart2){
                let data = response.response.chart2.details
                commit('setLabelStatisticsSecondPieChartTitle', response.response.chart2.title)
                commit('setLabelStatisticsSecondPieChartSeriesTitle', 'Revenue')
                if(data == null) {
                    commit('setLabelStatisticsSecondPieChartSeriesData', [])
                }else{
                    commit('setLabelStatisticsSecondPieChartSeriesData', data)
                } 
            }

            if(response.response.datatable.data){
                commit('setLabelStatisticsDatatableData', response.response.datatable)
            }

            if(response.response.cards){
                commit('setLabelStatisticsCards', response.response.cards)
            }
            commit('setShowLabelStatisticsChartsSection', true)
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t(response.response.errorMsg)
            })
        }
        commit('setIsLoading', false)
    },
    
    // ARTISTS
    async fetchAutocompleteLabelStatisticsArtist({commit}, payload){
        var dir = 'az'
        let artists = await api.getAutocompleteSearch(dir, payload, "type=artist")
        artists = artists.list.map((entry) => {
            return {
              artist: entry,
              value: entry.id,
            };
        })
        commit('setLabelStatisticsArtistOptions', artists)
    },

    // Product > Releases Autocomplete
    async fetchAutocompleteLabelStatisticsRelease({commit}, payload) {
        var dir = 'label/releases'
        let releases = await api.getAutocompleteSearch(dir, payload, undefined)
        releases = releases.list.map((entry) => {
            return {
                value: entry
            };
        })
        commit('setLabelStatisticsReleaseOptions', releases)
    },
     // Product > Tracks Autocomplete
    async fetchAutocompleteLabelStatisticsTrack({commit}, payload) {
        var dir = 'label/tracks'
        let tracks = await api.getAutocompleteSearch(dir, payload, undefined)
        tracks = tracks.list.map((entry) => {
            return {
              value: entry
            };
        })
        commit('setLabelStatisticsTrackOptions', tracks)
    },

    // Product > Releases - Tag search
    async fetchLabelStatisticsReleasesByTags({commit}, params){
        commit('setIsLoading', true)
        var dir = 'label/releases'
        let tags = 'TAG=[' + params.tags + ']&limit=none'
        let releases = await api.getAutocompleteSearch(dir, tags, undefined)
        releases = releases.list.map(entry => entry.id);

        if(releases.length === 0) {
            commit('setLabelStatisticsTagsSearchMessage', { msg: 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND', num: 0 })
        }

        if(releases.length === 1){
            commit('setLabelStatisticsTagsSearchMessage', { msg: 'lang_LABEL_STATISTICS_TAGS_SEARCH_RELEASE_SINGULAR', num: 1 })
        }

        if(releases.length > 1){
            commit('setLabelStatisticsTagsSearchMessage', { msg: 'lang_LABEL_STATISTICS_TAGS_SEARCH_RELEASE_PLURAL', num: releases.length })
        }
        
        commit('setLabelStatisticsDetailsProduct', releases)
        commit('setSelectedLabelStatisticsProduct', releases)
        commit('setIsLoading', false)

        
    },

    // Product > Label dropdown options (labels assigned to current Label Company)
    fetchLabelStatisticsLabelDropdownOptions({commit, rootGetters}){
        commit('setIsLoading', true)
        
        let labels = []
        let labelsDropdown = []
        let selectedLabelCompany = rootGetters.getSelectedLabelCompanyId
        
        // Handle breadcrumb issue where sometimes object is set instead of id
        if(selectedLabelCompany && typeof selectedLabelCompany === 'object' && selectedLabelCompany.constructor === Object) {
            selectedLabelCompany = selectedLabelCompany.id
        }
        
        // Get labels from Label Company's configured labels (same as Releases filter)
        rootGetters.getLabelCompanies.forEach((labelCompany) => {
            if(labelCompany.labels != null) {
                if (labelCompany.id == selectedLabelCompany) {
                    labels = labels.concat(labelCompany.labels)
                }
            }
        })
        
        labels.forEach((label) => {
            labelsDropdown.push({
                text: label.name_alv + ' (' + label.alvId + ')',
                value: label.alvId
            })
        })
        
        commit('setLabelStatisticsLabelDropdownOptions', labelsDropdown)
        commit('setIsLoading', false)
    },

    // Product > Releases - Label search
    async fetchLabelStatisticsReleasesByLabel({commit}, params){
        commit('setIsLoading', true)
        var dir = 'label/releases'
        let labelSearch = 'LABEL=[' + params.labelId + ']&limit=none'  // Now receives ALV ID
        let releases = await api.getAutocompleteSearch(dir, labelSearch, undefined)
        releases = releases.list.map(entry => entry.id);

        if(releases.length === 0) {
            commit('setLabelStatisticsLabelSearchMessage', { msg: 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND', num: 0 })
        }

        if(releases.length === 1){
            commit('setLabelStatisticsLabelSearchMessage', { msg: 'lang_LABEL_STATISTICS_CAPTION_LABEL_SEARCH_RELEASE_SINGULAR', num: 1 })
        }

        if(releases.length > 1){
            commit('setLabelStatisticsLabelSearchMessage', { msg: 'lang_LABEL_STATISTICS_CAPTION_LABEL_SEARCH_RELEASE_PLURAL', num: releases.length })
        }
        
        commit('setLabelStatisticsDetailsProduct', releases)
        commit('setSelectedLabelStatisticsProduct', releases)
        commit('setIsLoading', false)
    },

        // Product > Releases - Tag search
    async fetchLabelStatisticsTracksByTags({commit}, params){
        commit('setIsLoading', true)
        var dir = 'label/tracks'
        let tags = 'TAG=[' + params.tags + ']&limit=none'
        let tracks = await api.getAutocompleteSearch(dir, tags,undefined)
        tracks = tracks.list.map(entry => entry.id);

        if(tracks.length === 0) {
            commit('setLabelStatisticsTagsSearchMessage', { msg: 'lang_GENERAL_MESSAGE_NO_RECORDS_FOUND', num: 0 })
        }

        if(tracks.length === 1){
            commit('setLabelStatisticsTagsSearchMessage', { msg: 'lang_LABEL_STATISTICS_TAGS_SEARCH_TRACK_SINGULAR', num: 1 })
        }

        if(tracks.length > 1){
            commit('setLabelStatisticsTagsSearchMessage', { msg: 'lang_LABEL_STATISTICS_TAGS_SEARCH_TRACK_PLURAL', num: tracks.length })
        }

        commit('setLabelStatisticsDetailsProduct', tracks)
        commit('setSelectedLabelStatisticsProduct', tracks)
        commit('setIsLoading', false)
    },



    // FAVOURITS
    async fetchLabelStatisticsFavoriteDropdownValues({ commit, getters }) {
        let filters = await api.getDropdownValues(DIR, 'favourites')
        if (!Array.isArray(filters)) filters = []
        let selectedFavourite = getters.getSelectedLabelStatisticsFavorite
        let favorites = []

        if(selectedFavourite === null) {
            favorites.push({
                text: 'lang_LABEL_STATISTIC_ADD_NEW_FILTER',
                value: 'newFavorite'
            })
        }

        if(selectedFavourite !== null) {
            if(selectedFavourite.hasOwnProperty('id')) {
                favorites.push({
                    text: 'lang_LABEL_STATISTIC_DELETE_FILTER',
                    value: 'deleteFavorite'
                })
            }
        } 

         if(filters.length !== 0) {
            favorites.sort((a,b) => (a.text > b.text) ? 1 : (b.text > a.text) ? -1 : 0)
            favorites.push(
                { divider: true }
            )
            filters.forEach(element => {
                element['alvqa'] = 'label-statistics-list-favorite-dropdown-' + element.id
                favorites.push(element)
            })
        }
        
        commit('setLabelStatisticsFavoriteDropdownValues', favorites)
    },
    async doLabelStatisticsFavorite({ getters, commit, dispatch }) {
        dispatch('fetchLabelStatisticsFavoriteDropdownValues')
        let selectedFavourite = getters.getSelectedLabelStatisticsFavorite

        // check if the user clicked an existing favorite or selected delete or create new favorit
        if(selectedFavourite !== null) {
            if(selectedFavourite.hasOwnProperty('value')) {
                if(selectedFavourite.value === "newFavorite") {
                    commit('setShowLabelStatisticsCreateNewFavoriteDialog', true)
                }
                if(selectedFavourite.value === 'deleteFavorite') {
                    commit('setDeletionDialogContext', 'TempSaveSelectedLabelStatisticsFavorite')
                    commit('setShowDeletionDialog', true)
                    commit('setSelectedLabelStatisticsFavorite', null)
                }
            } else {
                commit('setSelectedLabelStatisticsFrom', selectedFavourite.monthFrom)
                commit('setSelectedLabelStatisticsTo', selectedFavourite.monthTo)
                commit('setSelectedLabelStatisticsRows', selectedFavourite.rows)
                commit('setSelectedLabelStatisticsColumnTitles', selectedFavourite.typeOfReport)
                commit('setSelectedLabelStatisticsOutputValues', selectedFavourite.outputValues)
                commit('setLabelStatisticsSearch', selectedFavourite.search),
                commit('setSelectedLabelStatisticsPlatforms', selectedFavourite.platforms),
                commit('setSelectedLabelStatisticsLeftChart', selectedFavourite.leftChart),
                commit('setSelectedLabelStatisticsRightChart', selectedFavourite.rightChart),
                commit('setSelectedLabelStatisticsSalesType', selectedFavourite.salesType),
                commit('setSelectedLabelStatisticsDistributors', selectedFavourite.distributors),
                commit('setSelectedLabelStatisticsDataTable', selectedFavourite.dataTable),
                commit('setLabelStatisticsArtistOptions', []),
                commit('setLabelStatisticsDetailsArtist', null),
                commit('setSelectedLabelStatisticsSearchMode', selectedFavourite.searchMode),
                commit('setSelectedLabelStatisticsSearchType', selectedFavourite.searchType),
                commit('setLabelStatisticsDetailsTags', selectedFavourite.tagsSearch),
                commit('setLabelStatisticsTagsSearchMessage', JSON.parse(selectedFavourite.tagsSearchMessage) )
                
                
                
                if(selectedFavourite.artist){
                    commit('setLabelStatisticsArtistOptions', [selectedFavourite.artist]),
                    commit('setLabelStatisticsDetailsArtist', selectedFavourite.artist.value)
                }

                if(selectedFavourite.region !== null) {
                    let regionsString = this._vm.$alvPlugin.createRegionsToString(selectedFavourite.region)
                    commit("setRegionDialogDetailsInclude",selectedFavourite.region.include)
                    commit("setRegionDialogDetailsExclude",selectedFavourite.region.exclude)
                    commit("setSelectedLabelStatisticsRegions",selectedFavourite.region)
                    commit('setSelectedLabelStatisticsRegionsString', regionsString)
                }else{
                    commit('setSelectedLabelStatisticsRegionsString', "")
                }

                if(selectedFavourite.product){
                    if(selectedFavourite.product.value === null || selectedFavourite.product.value === undefined){
                        commit('setSelectedLabelStatisticsProduct', null)
                    }
                    
                    if(selectedFavourite.product.value && selectedFavourite.product.value.alvId){
                        if(selectedFavourite.product.value.alvId.includes("LT")){
                            commit('setLabelStatisticsDetailsTrack', selectedFavourite.product.value)
                            commit('setLabelStatisticsTrackOptions', [selectedFavourite.product])
                            commit('setSelectedLabelStatisticsProduct', selectedFavourite.product.value.alvId)
                            commit('setLabelStatisticsDetailsProduct', selectedFavourite.product.value)
                        }

                        if(selectedFavourite.product.value.alvId.includes("LR")){
                            commit('setSelectedLabelStatisticsSearchType', 1)
                            commit('setLabelStatisticsDetailsRelease', selectedFavourite.product.value)
                            commit('setLabelStatisticsReleaseOptions', [selectedFavourite.product])
                            commit('setSelectedLabelStatisticsProduct', selectedFavourite.product.value.alvId)
                            commit('setLabelStatisticsDetailsProduct', selectedFavourite.product.value)
                        }
                    }else{
                            commit('setLabelStatisticsDetailsTrack', null)
                            commit('setLabelStatisticsTrackOptions', [])
                            commit('setSelectedLabelStatisticsProduct', null)
                            commit('setLabelStatisticsDetailsRelease', null)
                            commit('setLabelStatisticsReleaseOptions', [])
                            commit('setSelectedLabelStatisticsProduct', selectedFavourite.product.value)
                            commit('setLabelStatisticsDetailsProduct', selectedFavourite.product.value)
                    }

                }else{
                    commit('setSelectedLabelStatisticsProduct', '')
                    commit('setLabelStatisticsDetailsProduct', '')
                }
            }
        }
    },
    async saveNewLabelStatisticsFavorite({ getters, commit, dispatch }) {
        const favoriteName = String(
            getters.getLabelStatisticsCreateNewFavoriteDialogDetailsFavoriteName == null
                ? ''
                : getters.getLabelStatisticsCreateNewFavoriteDialogDetailsFavoriteName
        ).trim()
        if (!favoriteName) {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_NOT_SUCCESSFUL'),
            })
            return false
        }

        commit('setLabelStatisticsCreateNewFavoriteDialogDetailsFavoriteName', favoriteName)
        await dispatch('fetchLabelStatisticsFavoriteDropdownValues')
        if (isStatisticsFavoriteNameTaken(
            getters.getLabelStatisticsFavoriteDropdownValues,
            favoriteName
        )) {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_GENERAL_STATISTICS_VALIDATION_FAVORITE_NAME_EXISTS'),
            })
            return false
        }

        let queryParams = { "action" : "addFavorite"}
        let metaData = {
            'monthFrom'     : getters.getSelectedLabelStatisticsFrom,
            'monthTo'       : getters.getSelectedLabelStatisticsTo,
            'rows'          : getters.getSelectedLabelStatisticsRows,
            'outputValues'  : getters.getSelectedLabelStatisticsOutputValues,
            'search'        : getters.getLabelStatisticsSearch,
            'typeOfReport'  : getters.getSelectedLabelStatisticsColumnTitles,
            'region'        : getters.getSelectedLabelStatisticsRegions,
            "text"          : favoriteName,
            'platforms'     : getters.getSelectedLabelStatisticsPlatforms,
            'leftChart'     : getters.getSelectedLabelStatisticsLeftChart,
            'rightChart'    : getters.getSelectedLabelStatisticsRightChart,
            'salesType'     : getters.getSelectedLabelStatisticsSalesType,
            'distributors'  : getters.getSelectedLabelStatisticsDistributors,
            'dataTable'     : getters.getSelectedLabelStatisticsDataTable,
            'artist'        : getters.getLabelStatisticsDetailsArtist,
            'product'       : getters.getSelectedLabelStatisticsProduct,
            'searchType'    : getters.getSelectedLabelStatisticsSearchType,
            'searchMode'    : getters.getSelectedLabelStatisticsSearchMode,
            'tagsSearch'    : getters.getLabelStatisticsDetailsTags,
            'tagsSearchMessage' : JSON.parse(JSON.stringify(getters.getLabelStatisticsTagsSearchMessage))
        }
        
        let response = await api.triggerAction(DIR, metaData, queryParams)
        if(response && response.error === -1) {
            dispatch('fetchLabelStatisticsFavoriteDropdownValues')
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_ADDING_WAS_SUCCESSFUL')
            })
            commit('setSelectedLabelStatisticsFavorite', response.response.newFilter)
            return true
        } else {
            const errorMsg = response && response.response && response.response.errorMsg
                ? response.response.errorMsg
                : 'lang_GENERIC_SNACKBAR_ADDING_WAS_NOT_SUCCESSFUL'
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t(errorMsg)
            })
            return false
        }
    },

    async deleteTempSaveSelectedLabelStatisticsFavorite({ getters, commit, dispatch }) {
        let selectedFavoriteId = getters.getTempSaveSelectedLabelStatisticsFavorite.id
        let response = await api.deleteEntries(DIR + '/favourites', [selectedFavoriteId])

        if(response.error === -1) {
            commit('setTempSaveSelectedLabelStatisticsFavorite', [])
            dispatch('fetchLabelStatisticsFavoriteDropdownValues')
            commit('setSnackbar', {
                type: 'success',
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_SUCCESSFUL')
            })
        } else {
            commit('setSnackbar', {
                type: 'error',
                msg: i18n.t('lang_GENERIC_SNACKBAR_DELETE_NOT_SUCCESSFUL')
            })
        }
    }
}

export default {
    state, getters, actions, mutations
}